module.exports = __webpack_public_path__ + "font/ucicon-division.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/ucmp/fonts/ucicon-division.svg?v=1683532529387
// module id = 2568
// module chunks = 17